import { AppBar } from '@carto/react-ui';
import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
  backgroundColor: '#fff',
  '& a svg': {
    width: 164,
    height: 42,
  },
  '& .MuiTypography-root': {
    color: '#000',
  },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));
